export function NotFound() {
    return (
        <div>
            <h1 className="text-white">Page Not Found</h1>
        </div>
    )
}
